export default __webpack_public_path__ + "static/media/reach_out_directly.94dcab82.svg";